export default __webpack_public_path__ + "static/media/arrow-left.6fd93e0d.svg";